import { render, staticRenderFns } from "./PortfolioFunds.vue?vue&type=template&id=1001daf6"
import script from "./PortfolioFunds.vue?vue&type=script&lang=js"
export * from "./PortfolioFunds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports